export { createBrowserHistory, createMemoryHistory } from 'history';
export { createRouterSelector, MemoryRouter, Redirect, Router, RouterActions, RouterSubscriber, usePathParam, useQueryParam, useRouter, useRouterActions, withRouter } from './controllers';
export { RouteComponent, Link } from './ui';
export { createLegacyHistory, createRouterContext, findRouterContext, generatePath, matchRoute } from './common/utils';
export { invokePluginLoad } from './controllers/plugins';
// extra exports for resources only
export { RouterStore, useRouterStoreActions, getRouterState } from './controllers/router-store';
export { DEFAULT_MATCH, DEFAULT_ROUTE } from './common/constants';

// re-export resources entry-point to keep it backwards compatible with 0.20.x version
export { createResource, ResourceDependencyError, ResourceSubscriber, useResource, useResourceStoreContext } from './resources';